<template>
  <div>
    <div class="login-leftbox">
      <v-carousel
      cycle
      hide-delimiter-background
      :show-arrows="false"
      light
      >
        <v-carousel-item
          v-for="(item, i) in items"
          :key="i"
          :src="item.src"
          reverse-transition="fade-transition"
          transition="fade-transition"
        >
        </v-carousel-item>
      </v-carousel>
     
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { validationMixin } from "vuelidate";
import {
  required,
  email,
  minLength,
  maxLength,
  sameAs,
  numeric,
} from "vuelidate/lib/validators";
import JwtService from ".././common/jwt.service";
export default {
    data () {
      return {
        items: [
          {
            src: 'Frame1.jpg',
          },
          {
            src: 'Frame2.jpg',
          },
          {
            src: 'Frame3.jpg',
          },
          {
            src: 'Frame4.jpg',
          },
          {
            src: 'Frame5.jpg',
          },
          {
            src: 'Frame6.jpg',
          },
          {
            src: 'Frame7.jpg',
          },
        ],
      }
    },
  }
</script>
<style scoped>

</style>